import { render, staticRenderFns } from "./saque.vue?vue&type=template&id=509a6e60&scoped=true&"
import script from "./saque.vue?vue&type=script&lang=js&"
export * from "./saque.vue?vue&type=script&lang=js&"
import style0 from "./saque.vue?vue&type=style&index=0&id=509a6e60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509a6e60",
  null
  
)

export default component.exports